/**
 * 注意，Ballon的children如果是组件，需要保证支持任意data-attr的注入
 * next的Balloon写的比较死板，应该是设计者只考虑了children为dom的情况，它是通过在dom上注入aria-haspopup和aria-expanded实现的
 */
import React from 'react';
import { Balloon } from '@alifd/next';

export default function(props) {
  return (
    <Balloon
      triggerType="hover"
      delay={500}
      align="br"
      style={{
        maxWidth: 350,
      }}
      closable={false}
      animation={false}
      {...props}
    />
  );
}
